var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "md:ml-8 flex-1" }, [
    _c(
      "div",
      { staticClass: "p-2 sm:p-6 bg-white rounded-lg" },
      [
        _c("SectionHeader", {
          attrs: {
            title: "Functional Assessment",
            currentUser: _vm.currentUser,
          },
          on: {
            edit: function ($event) {
              return _vm.$emit("edit")
            },
          },
        }),
        _c("hr", { staticClass: "border-t border-gray-100 mb-4" }),
        _c(
          "InfoSection",
          [
            _c("InfoField", { attrs: { label: "Mobility Status" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Level: " + _vm._s(_vm.proejctData.mobility_level || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Notes: " +
                    _vm._s(_vm.proejctData.mobility_notes || "N/A") +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", { attrs: { label: "Communication Ability" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Notes: " +
                    _vm._s(_vm.proejctData.communication_notes || "N/A") +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", { attrs: { label: "Cognitive Status" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Concerns: " +
                    _vm._s(_vm.proejctData.cognitive_concerns || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Notes: " + _vm._s(_vm.proejctData.cognitive_notes || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " General Notes: " +
                    _vm._s(_vm.data.cognitive_general_notes || "N/A") +
                    " "
                ),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }